import { useQuery } from '@tanstack/react-query';
import type { UseQueryOptions } from '@tanstack/react-query';
import type { ChangeHistoryFilter, ProductChangeHistoryResponse } from 'v2/interfaces/productChangeHistory';
import productChangeHistoryService from 'v2/services/ProductChangeHistory';

type Payload = {
  productId: number;
  filter: ChangeHistoryFilter;
};

export function useProductChangeHistory(
  { productId, filter }: Payload,
  options: Omit<UseQueryOptions<ProductChangeHistoryResponse>, 'queryKey' | 'queryFn'> = {}
) {
  return useQuery({
    queryKey: ['product', productId, 'changeHistory', filter],
    queryFn: () => productChangeHistoryService.getChangeHistory(productId, filter),
    ...options
  });
}
